import { useEffect, useState } from "react";
import { Rocket, X } from "lucide-react";

const STORAGE_KEY = "kidsai-coming-soon-banner-dismissed";

export const StatusBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(localStorage.getItem(STORAGE_KEY) !== "true");
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  return (
    <div className="sticky top-0 z-[60] w-full bg-gradient-to-r from-kid-purple via-kid-pink to-kid-blue text-white shadow-md">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 h-9 sm:h-10 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0 text-xs sm:text-sm font-fredoka">
          <Rocket className="w-4 h-4 shrink-0 animate-pulse" />
          <span className="truncate sm:hidden">
            🚧 Under construction — Coming soon!
          </span>
          <span className="hidden sm:inline truncate">
            🚧 <strong className="font-bold">Website still under construction</strong> — Coming soon! Thanks for your patience while we build something amazing.
          </span>
        </div>
        <button
          onClick={dismiss}
          aria-label="Dismiss banner"
          className="shrink-0 h-10 w-10 -mr-2 flex items-center justify-center rounded-full hover:bg-white/15 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default StatusBanner;
